exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".introduction-section {\n\n}\n\n.introduction-body {\n    display: grid;\n    grid-template-columns: 7em auto 7em auto;\n    grid-gap: 1em;\n    gap: 1em;\n}\n\n.introduction-body img {\n    width: 10em;\n    height: auto;\n}\n\n@media (max-width: 480px) {\n    .introduction-body {\n        grid-template-columns: 10em auto;\n    }\n\n    .introduction-body img {\n        width: 10em;\n    }\n}", ""]);

// exports
